export default __webpack_public_path__ + "static/media/italic.f9a11f7b.svg";